


























import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
@Component
export default class InsCmsList extends Vue {
  @Prop({ default: '' }) private catKey!: string; // key值

  contents: object[] = [];
  contTime: object = {};

  // 获取关于cms内容列表
  getContents () {
    this.$Api.cms
      .getContentsByCatKeyEx({
        Key: this.catKey,
        Page: 1,
        PageSize: 3,
        IsMobile: this.isMobile
      })
      .then(result => {
        this.contents = result.Data;
        // console.log(result, 'getContentsByCatKeyEx');

        for (var i = 0; i < result.Data.length; i++) {
          var contdate = result.Data[i].ContentDateTime;
          this.contTime = contdate.substring(0, 10);
        }
        // console.log(this.contTime, '时间');
      });
  }

  get isMobile () {
    return this.$store.state.isMobile;
  }

  mounted () {
    this.getContents();
  }

  @Watch('isMobile', { deep: true })
  onMediaChange () {
    this.getContents();
  }
}
